import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography, Button } from '@mui/material';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import todo_task_perfomance from '../../../../assets/images/todo_task_perfomance.svg';
import { DataGrid } from '@mui/x-data-grid';
import EmployeeNamePic from '../../EmployeeNamePic/EmployeeNamePic';
import { fonts } from '../../../themes/themes';
import SearchComponent from '../../SearchComponent';
import CustomAutoComplete from '../../CustomAutoComplete/CustomAutoComplete';
import TeamReviewModalController from '../../../Modals/PerofomanceModals/TeamReviewModal/TeamReviewModalController';
import moment from 'moment';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import { PENDING, COMPLETED, baseDateFormatting } from '../../../helper';
import Loader from '../../../Lottifiers/Loader/Loader';
import {
  setEvaluatorSheetId,
  setKpiId,
  setApiTrigger,
} from '../../../../infra/aggregates/myProfile/EvaluatorData/evaluatorData';
import {
  setPerformanceStatusFilter,
  setPerformanceSearchData,
  setPage,
  setTablePageSize,
} from '../../../../infra/aggregates/myProfile/Performance/Performance';
import { DateField } from '../../../../components';
interface Prop {
  trans: any;
  myTeam: boolean;
}
function KPIPerfomancePresenter({ trans, myTeam }: Prop) {
  const [openFormModal, setOpenFormModal] = useState(false);
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const myPerformance = useAppSelector(
    (state) => state.PerformanceSlice?.PerformanceData,
  );
  const performanceStatusFilter = useAppSelector(
    (state) => state.PerformanceSlice?.performanceStatusFilter,
  );
  const performance = useAppSelector(
    (state) => state.PerformanceSlice.performanceStatusCount,
  );
  const kpiTableLoader = useAppSelector(
    (state) => state.PerformanceSlice?.kpiTableLoader,
  );
  const page = useAppSelector((state) => state.PerformanceSlice?.page);
  const tablePageSize = useAppSelector(
    (state) => state.PerformanceSlice?.tablePageSize,
  );

  const expired = (date: any) => {
    return new Date(date).getTime() < new Date().getTime();
  };

  const styles = {
    completedbox: {
      color: '#4CAF50',
      height: '2em',
      width: 'auto',
      backgroundColor: '#EDF7ED',
      fontSize: '0.75em',
      fontFamily: fonts.fontFamily,
    },
    inprogressbox: {
      color: '#FFB400',
      height: '2em',
      width: 'auto',
      backgroundColor: '#F6EEDC',
      fontSize: '0.75em',
      fontFamily: fonts.fontFamily,
    },
    pendingbox: {
      color: '#FF5263',
      height: '2em',
      width: 'auto',
      backgroundColor: '#FFEDEF',
      fontSize: '0.75em',
      fontFamily: fonts.fontFamily,
    },
    reopenedBox: {
      color: '#2196F3',
      height: '2em',
      width: 'auto',
      backgroundColor: '#E8F4FE',
      fontSize: '0.75em',
      fontFamily: fonts.fontFamily,
    },
  };

  const tableColumns: any = [
    {
      field: 'employeeName',
      headerName: trans('Employee'),
      flex: 1,
      headerAlign: 'center',
      align: 'left',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return (
          <EmployeeNamePic
            name={params?.row?.employeeName}
            picture={params?.row?.profileImage}
            fontWeight="bold"
          />
        );
      },
    },
    {
      field: 'kpiTitle',
      headerName: trans('review-form'),
      width: 250,
      flex: 2,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'cycleStartDate',
      headerName: trans('Start Date'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return (
          <DateField
            value={params?.row?.cycleStartDate}
            format={baseDateFormatting}
          />
        );
      },
    },
    {
      field: 'cycleEndDate',
      headerName: trans('due-date'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return (
          <DateField
            value={params?.row?.cycleEndDate}
            format={baseDateFormatting}
          />
        );
      },
    },
    {
      field: 'status',
      flex: 1,
      width: 200,
      headerName: trans('Status'),
      headerClassName: 'header',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => {
        return params?.row?.status === COMPLETED ? (
          <Button style={styles.completedbox}>{t('Completed')}</Button>
        ) : params?.row?.status === 'InProgress' ? (
          <Button style={styles.inprogressbox}>{t('InProgress')}</Button>
        ) : params?.row?.status === PENDING ? (
          <Button style={styles.pendingbox}>{t('Pending')}</Button>
        ) : params?.row?.status === 'reOpened' ? (
          <Button style={styles.reopenedBox}>{t('Re-Opened')}</Button>
        ) : null;
      },
    },
    {
      field: 'action',
      flex: 1,
      headerName: trans('Action'),
      headerClassName: 'header',
      headerAlign: 'center',
      align: 'center',
      width: 200,
      height: 70,
      renderCell: (params: any) => {
        return (
          !(params.row?.cyclePublished && expired(params.row?.duDate)) && (
            <Box
              style={{
                border: '1px solid #E6E8EF',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0.5em',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
              onClick={() => {
                dispatch(setKpiId(params?.row?.kpiId));
                dispatch(setEvaluatorSheetId(params?.row?.id));
                setOpenFormModal(true);
              }}
            >
              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  color: '#4CAF50',
                  fontSize: '0.75em',
                }}
              >
                {params?.row?.status === PENDING
                  ? trans('start-review')
                  : trans('opened-form')}
              </Typography>
            </Box>
          )
        );
      },
    },
  ];

  const statusBoxData = [
    {
      id: 1,
      statusName: trans('total-form'),
      value: performance?.all,
      img: todo_task_perfomance,
      bgColor: '#4CAF5033',
    },
    {
      id: 2,
      statusName: trans('assigned-form'),
      value: performance.assigned,
      img: todo_task_perfomance,
      bgColor: '#F6F6F6',
    },
    {
      id: 3,
      statusName: trans('pending-form'),
      value: performance.pending,
      img: todo_task_perfomance,
      bgColor: '#FFF5E5',
    },
    {
      id: 5,
      statusName: trans('completed-form'),
      value: performance.completed,
      img: todo_task_perfomance,
      bgColor: '#EDF7ED',
    },
    {
      id: 6,
      statusName: trans('overdue-form'),
      value: performance.overdue,
      img: todo_task_perfomance,
      bgColor: '#EDF7ED',
    },
  ];

  const modifiedTableData = _.map(myPerformance, function (item: any) {
    return {
      ...item,
      id: item?.id,
      employeeName: item?.employeeName,
      kpiTitle: item?.kpiTitle,
      cycleStartDate: item?.cycleStartDate,
      cycleEndDate: item?.cycleEndDate,
      duDate: item?.cycleEndDate,
      action: trans('start-review'),
    };
  });
  //Search Data
  function debounce(callback: any, delay: any) {
    let timerId: any;
    return function (...args: any) {
      clearTimeout(timerId);
      timerId = setTimeout(() => {
        callback(...args);
      }, delay);
    };
  }
  const handleChange = (data: any) => {
    dispatch(setPerformanceSearchData(data));
    dispatch(setApiTrigger(new Date()));
  };
  const optimizedFn = debounce(handleChange, 1200);
  const filterStatusName = ['COMPLETED', 'PENDING'];
  return (
    <>
      <Box
        sx={{
          padding: '1em',
          backgroundColor: '#FFFFFF',
          boxShadow: '0px 1px 1px #0000001A',
          borderRadius: '10px',
          width: '100%',
        }}
      >
        <Grid container spacing={2}>
          <Grid item lg={3} md={4} xs={12}>
            <SearchComponent
              onChange={(searchData: React.ChangeEvent<HTMLInputElement>) =>
                optimizedFn(searchData)
              }
            />
          </Grid>
          <Grid item lg={5} md={2} xs={12}></Grid>
          <Grid item lg={2} md={3} xs={12}>
            <CustomAutoComplete
              label={trans('filter-by-status')}
              options={filterStatusName}
              defaultValue={performanceStatusFilter}
              required={false}
              onChange={(e: any, newValue: any) => {
                dispatch(setPerformanceStatusFilter(newValue));
                dispatch(setApiTrigger(new Date()));
              }}
            />
          </Grid>
          <Grid item lg={2} md={3} xs={12}>
            <CustomAutoComplete
              label={trans('filter-by-form')}
              required={false}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} marginTop={'0.5em'}>
          {statusBoxData &&
            statusBoxData.length > 0 &&
            statusBoxData.map((item: any) => {
              const { statusName, value, img, bgColor } = item;
              return (
                <>
                  <Grid item lg={2} md={4} xs={6}>
                    <Box
                      sx={{
                        padding: '0.75em',
                        backgroundColor: '#FAFAFA',
                        boxShadow: '0px 1px 2px #EBEBEB',
                        width: 'auto',
                        height: 'auto',
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box>
                        <Typography
                          style={{
                            color: '#0000008A',
                            fontSize: '0.75em',
                            fontWeight: 'bold',
                            fontFamily: 'Lato',
                          }}
                        >
                          {statusName}
                        </Typography>
                        <Typography
                          style={{
                            color: '#000000',
                            fontSize: '0.75em',
                            fontWeight: 'bold',
                            fontFamily: 'Lato',
                          }}
                        >
                          {value}
                        </Typography>
                      </Box>
                      <Box
                        style={{
                          backgroundColor: bgColor,
                          width: '1.5em',
                          height: '1.5em',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: '4px',
                        }}
                      >
                        <img
                          src={img}
                          style={{
                            width: '1em',
                            height: '1em',
                          }}
                        />
                      </Box>
                    </Box>
                  </Grid>
                </>
              );
            })}
        </Grid>

        <Grid container marginTop={'1.7em'}>
          <Grid item xs={12}>
            <Box
              sx={{
                '& .header': {
                  backgroundColor: '#F5F5F5',
                },
              }}
            >
              {kpiTableLoader ? (
                <Loader height={100} width={200} />
              ) : (
                <DataGrid
                  sx={{
                    color: '#575757',
                    font: 'normal normal normal 14px/24px Lato;',
                  }}
                  page={page}
                  onPageChange={(newPage) => {
                    dispatch(setPage(newPage));
                    dispatch(setApiTrigger(new Date()));
                  }}
                  pageSize={tablePageSize}
                  rowCount={performance.all}
                  onPageSizeChange={(newPageSize) => {
                    dispatch(setTablePageSize(newPageSize));
                    dispatch(setApiTrigger(new Date()));
                  }}
                  rowsPerPageOptions={[10, 25, 50]}
                  autoHeight
                  disableExtendRowFullWidth
                  disableSelectionOnClick
                  rows={modifiedTableData}
                  columns={tableColumns}
                  componentsProps={{
                    pagination: {
                      labelRowsPerPage: t('Rows per page'),
                    },
                  }}
                />
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
      {openFormModal && (
        <TeamReviewModalController
          closeModal={() => setOpenFormModal(false)}
          isModalOpen={openFormModal}
        />
      )}
    </>
  );
}
export default KPIPerfomancePresenter;
